import React from 'react';

import {
  SearchComponent,
  ISearchComponent,
} from '../../core/components/SearchComponent';

import lineModules from '../../core/components/lineModules'
import { Container } from './styles';
import { useParams } from 'react-router-dom';
import { useConfiguration } from '../../../../hooks/Configuration';

interface ValidationRules {
  type: 'email' | 'required' | 'min' | 'max' | 'length';
  message?: string;
  quantity?: number;
}

interface ValidationSchema {
  name: string;
  type: 'string' | 'number' | 'boolean';
  label: string;
  rules: Array<ValidationRules>;
}

const ExpositorsList: React.FC = () => {
  const endpoint = '/expositorlist';
  const title = 'Cortesias';

  const { projectHash, eventHash } = useConfiguration();

  const schema: Record<string, any> = {
    _id: { ref: '_id', column: '_id', label: 'ID', show: false },
    hash: { ref: 'hash', column: 'hash', label: 'Hash' },
    category: { ref: 'category', column: 'category', label: 'Categoria' },
    title: { ref: 'title', column: 'title', label: 'Expositor' },

    quantity: { ref: 'quantity', column: 'quantity', label: 'Quantidade de ingressos' },

    phone: { ref: 'phone', column: 'phone', label: 'Telefone' },
    product: {
      ref: 'product',
      column: 'product_response',
      includeColumn: 'title',
      label: 'Produto / Ingresso',
    },
    createdAt: {
      ref: 'created_at',
      column: 'createdAt',
      label: 'Data de Criação',
      mask: 'date',
    },
  };

  const formSchema = {
    hash: { model: 'input', type: 'text', name: 'hash', label: 'Hash (Código Promocional)' },
    category: {
      model: 'selectSimple',
      category: 'text',
      name: 'category',
      label: 'Categoria',
      defaultValue: 'Isenção',

      options: [
        { id: 'Isenção', value: 'Isenção', label: 'Isenção' },
        { id: 'Organização', value: 'Organização', label: 'Organização' },

      ],
    },
    title: { model: 'input', type: 'text', name: 'title', label: 'Nome do Participante' },
    quantity: { model: 'input', type: 'text', name: 'quantity', label: 'Quantidade de ingressos', defaultValue: '1' },

    phone: { model: 'input', type: 'text', name: 'phone', label: 'Telefone' },

    product_id: {
      alias: 'product_id',
      model: 'selectApiDirect',
      name: 'product_id',
      label: 'Produto / Ingresso',
      project_id: projectHash,
      endpoint: '/products-manager',
    },
  };

  const formSchemaUpdate = formSchema;

  const formValidation: Record<string, ValidationSchema> = {

  };

  const config: ISearchComponent = {
    idKey: `${endpoint}-${projectHash}-${eventHash}`,
    title,
    endpoint,
    schema,
    autoStart: true,
    headModules: [
      () =>
        lineModules.create({
          title,
          formSchema,
          validationSchema: formValidation,
          endpoint,
        }),
    ],
    bodyModules: [
      (lineData: Record<string, any>) =>
        lineModules.updateUnique({
          lineData,
          title,
          formSchema: formSchemaUpdate,
          validationSchema: {},
          endpoint,
        }),
      (lineData: Record<string, any>) =>
        lineModules.delete({
          lineData,
          title,
          formSchema,
          validationSchema: formValidation,
          endpoint,
        }),
    ],
  };
  return (
    <Container>
      <SearchComponent {...config} />
    </Container>
  );
};

export default ExpositorsList;
